import React, { Suspense } from "react";
import { Card } from "antd";
import Loader from "util/Loader";

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { error: null, errorInfo: null };
    }

    componentDidCatch(error, errorInfo) {
        this.setState({
            error: error,
            errorInfo: errorInfo,
        });
    }

    render() {
        if (this.state.errorInfo) {
            return (
                <Card className="w-100">
                    <h2>Something went wrong.</h2>
                    <details style={{ whiteSpace: "pre-wrap" }}>
                        {this.state.error && this.state.error.toString()}
                        <br />
                        {this.state.errorInfo.componentStack}
                    </details>
                </Card>
            );
        }

        return <Suspense fallback={<Loader />}>{this.props.children}</Suspense>;
    }
}

export default ErrorBoundary;
